/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/order */
import React, { Suspense } from 'react';
import { Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';
import Main from 'Layouts/Main/Main';

// Route modules
import Loading from 'Layouts/Main/Loading/Loading';

import auth from './auth';
import onboarding from './onboarding';
import pdfviewer from './pdfviewer';
// Authen wrapper
import { isAuthenticatedUser } from './helpers/authWrapper';

const concat = (...args) => args.reduce((acc, val) => [...acc, ...val]);

const routes = concat(auth, onboarding, pdfviewer);

const Routes = () => (
  <BrowserRouter>
    <Switch>
      {routes.map(({ redirect, path, exact, ContentComponent, Layout, bodyClass }) => (
        <Route
          path={path}
          exact={exact}
          key={path}
          render={props => {
            if (redirect) {
              return <Redirect to={redirect} />;
            }
            return (
              <Layout {...props} bodyClass={bodyClass}>
                <Suspense fallback={<Loading />}>
                  <ContentComponent {...props} />
                </Suspense>
              </Layout>
            );
          }}
        />
      ))}
      <Route path="/" component={isAuthenticatedUser(Main)} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
